import './branch.scss';
import { appConfig } from '../../src/appConfig';
import { setupLayout } from '../Shared/layout';
import { setupGoogleMap } from '../../src/module/google-map';

setupLayout();

setupGoogleMap({
    apiKey: appConfig.googleMapApiKey,
    languageIsoCode: (document.getElementById('inputHiddenForPageLanguageIsoCode') as HTMLInputElement).value,
    styles: appConfig.googleMapStyles
});

const jsButtonElements = document.querySelectorAll<HTMLElement>('.js-button');

jsButtonElements.forEach(jsButtonElem => {
    jsButtonElem.addEventListener('click', () => {

        jsButtonElements.forEach(elem => elem.classList.remove('active'));
        jsButtonElem.classList.add('active');

        const selectedBranch = jsButtonElem.dataset.branch;

        document.querySelectorAll<HTMLElement>('.js-branch').forEach(jsBranchElem => {
            const branch = jsBranchElem.dataset.branch;
            if (selectedBranch === 'all' || branch === selectedBranch) {
                jsBranchElem.style.display = 'block';
            }
            else {
                jsBranchElem.style.display = 'none';
            }
        });
    });
});

// track
document.querySelectorAll<HTMLLinkElement>('.js-phoneLink').forEach(el => {
    const branch = el.dataset.branch;
    el.addEventListener('click', () => {
        gtag('event', 'call', {
            send_to: appConfig.googleAnalyticsId,
            event_category: 'engagement',
            event_label: branch
        });
        gtag('event', 'generate_lead', {
            send_to: appConfig.googleAnalytics4Id
        });
        gtag('event', 'call', {
            send_to: appConfig.googleAnalytics4Id,
            branch
        });
        fbq('track', 'Contact');
    });
});

document.querySelectorAll<HTMLLinkElement>('.js-locationLink').forEach(el => {
    const branch = el.dataset.branch;
    el.addEventListener('click', () => {
        gtag('event', 'find_location', {
            send_to: appConfig.googleAnalyticsId,
            event_category: 'engagement',
            event_label: branch
        });
        gtag('event', 'generate_lead', {
            send_to: appConfig.googleAnalytics4Id
        });
        gtag('event', 'find_location', {
            send_to: appConfig.googleAnalytics4Id,
            branch
        });
        fbq('track', 'FindLocation');
    });
});
